
import './App.css';
import React, { Component } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './Home/Home';
import Login from './Login/Login';
// import Test from './Test/Test';

class App extends Component {

  render() {
    return (
      <div>
        <AppRoute />
      </div>
    )
  }
}

function AppRoute() {
  return (
    <BrowserRouter >
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/login" component={Login} />
        <Route path="/home" component={Home} />
        {/* <Route path="/migratedata" component={Test} /> */}
      </Switch>
    </BrowserRouter >
  );
}

export default (App);